'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/* eslint-disable max-len */

exports.default = {
	icon: 'M6,11L5,8l11-8L0.622,5.914c0,0-0.672,0.23-0.619,0.655c0.053,0.425,0.602,0.619,0.602,0.619l3.575,1.203L5.8,13.545l2.742-2.411l-0.007-0.005l3.607,2.766c0.973,0.425,1.327-0.46,1.327-0.46L16,0L6,11z',
	popupUrl: 'https://telegram.me/share/url?url={url}&title={title}',
	popupWidth: 600,
	popupHeight: 500
};